import { useState, useEffect, useRef } from "react";
import {
  Button,
  Input,
  Modal,
  Checkbox,
  Upload,
  Image,
  Popconfirm,
  Select,
} from "antd";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import "./CreateNewAlbum.scss";
import { Toast } from "primereact/toast";
import { uploadFile } from "../../services/FileService";
import { RcFile } from "antd/es/upload";
import { Editor } from "primereact/editor";
import { getAllEvents } from "../../services/EventService";
import { AxiosResponse } from "axios";
import { EventDto } from "../../models/Event";
import {
  createOneAlbum,
  getOneAlbum,
  updateOneAlbum,
} from "../../services/GalleryService";

const CreateNewAlbumModal = (props: any) => {
  const CheckboxGroup = Checkbox.Group;
  const toast = useRef<any>(null);
  const [checked, setChecked] = useState<any>([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [listData, setListData]: any = useState([""]);
  const [allData, setAllData] = useState<any>([]);
  const [errorSubject, setErrorSubject] = useState(false);
  const [errorEvent, setErrorEvent] = useState(false);
  const [photos, setPhotos] = useState<any>([]);
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";
  const [HTMLtext, setHTMLText] = useState<any>("");
  const [eventOptions, setEventOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const Option = Select.Option;
  const [selectedAlbum, setSelecteAlbum] = useState<any>();

  useEffect(() => {
    if (props.selectedAlbums)
      getOneAlbum(props.selectedAlbums.id).then((res: AxiosResponse) => {
        setSelecteAlbum(res.data.result);
        setAllData(res.data.result);
        setHTMLText(res?.data?.result?.content);
        setPhotos(res.data.result?.photos);
      });
  }, [props.selectedAlbums]);

  useEffect(() => {
    getAllEvents().then((res: AxiosResponse) => {
      let events = res.data.result?.map((event: EventDto) => {
        return { label: event.name, value: event.id };
      });
      setEventOptions(events);
    });
  }, []);

  const handleSubject = (e: any) => {
    setErrorSubject(false);
    setAllData({ ...allData, title: e.target.value });
  };

  const handleEvent = (e: any, value: any) => {
    setErrorEvent(false);
    setAllData({ ...allData, event: { id: e } });
  };

  const handleUpload = async (file: any) => {
    try {
      const response = await uploadFile(file.file);
      const uploadedPhotoWithBackend = response.data;

      setPhotos((prevPhotos: any) => [...prevPhotos, uploadedPhotoWithBackend]);

      toast?.current?.show({
        severity: "success",
        detail: "Slika je uspešno uploadovana!",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast?.current?.show({
        severity: "error",
        detail: "Došlo je do greške prilikom uploada slike.",
        life: 3000,
      });
    }
  };

  const deletePhoto = (image: any) => {
    let copyImage = [...photos];
    let newFilter = copyImage.filter((imageD: any) => imageD.id !== image.id);
    setPhotos(newFilter);
  };

  const handleSaveAlbum = async () => {
    if (!allData.title) {
      setErrorSubject(true);
      return props.toast?.current?.show({
        severity: "error",
        detail: `Unesite naslov!`,
        life: 3000,
      });
    } else if (photos.length < 1) {
      return props.toast?.current?.show({
        severity: "error",
        detail: `Izaberite bar jednu sliku!`,
        life: 3000,
      });
    } else if (!allData.event) {
      return props.toast?.current?.show({
        severity: "error",
        detail: `Izaberite događaj!`,
        life: 3000,
      });
    } else {
      let sendDataSaveAlbum = { ...allData, content: HTMLtext, photos: photos };

      if (props.selectedAlbums) {
        updateOneAlbum(sendDataSaveAlbum.id, sendDataSaveAlbum).then(
          (res: AxiosResponse) => {
            props.handleOpenModal();
          }
        );
      } else {
        createOneAlbum(sendDataSaveAlbum).then((res: AxiosResponse) => {
          props.handleOpenModal();
        });
      }
    }
  };

  const deleteGroupImages = () => {
    setPhotos([]);
  };

  const beforeUpload = (file: RcFile) => {
    const allowedTypes = ["image/jpeg", "image/png"];
    const isAllowedType = allowedTypes.includes(file.type);
    const isAllowedSize = file.size / 1024 / 1024 < 50;

    if (!isAllowedType) {
      toast?.current?.show({
        severity: "error",
        detail: "Dozvoljeni formati slika su JPEG i PNG!",
        life: 3000,
      });
    }

    if (!isAllowedSize) {
      toast?.current?.show({
        severity: "error",
        detail: "Slika ne sme biti veća od 50MB!",
        life: 3000,
      });
    }

    return isAllowedType && isAllowedSize;
  };

  return (
    <Modal
      maskClosable={false}
      open={props.showModal}
      title={`${selectedAlbum ? selectedAlbum.title : "Novi album"} `}
      className={"create-new-album-modal large-width"}
      onCancel={() => {
        props.handleOpenModal();
      }}
      onOk={() => {
        props.handleOpenModal();
      }}
      footer={[
        <Button
          key={1}
          onClick={() => {
            setHTMLText("");
            props.handleOpenModal();
          }}
        >
          Odustani
        </Button>,
        <CustomButton
          danger={false}
          htmlType={"submit"}
          type={"primary"}
          key={2}
          function={() => {
            //setHTMLText("");
            handleSaveAlbum();
          }}
          text={"Pošalji"}
        />,
      ]}
    >
      <div className="box">
        <div className="modal-container">
          <Input
            type="text"
            className={errorSubject ? "input-label error" : "input-label"}
            placeholder="Unesite naslov"
            onChange={handleSubject}
            value={allData.title}
          />
          <Select
            placeholder="Izaberite dogadjaj"
            value={allData?.event?.name}
            className={
              errorEvent
                ? "input-label select-error input-margin"
                : "input-label input-margin"
            }
            onChange={handleEvent}
            options={eventOptions}
          >
            {eventOptions.map((el: any, i: number) => (
              <Option key={i} value={el.value}>
                {el.label}
              </Option>
            ))}
          </Select>

          <Editor
            value={HTMLtext}
            onTextChange={(e) => setHTMLText(e.htmlValue)}
            style={{ height: "270px" }}
            placeholder="Sadrzaj..."
          />
          <p className="text">
            <span className="required">*</span>Dodajte prilog:
          </p>
          <Upload
            multiple
            beforeUpload={beforeUpload}
            accept="image/*"
            customRequest={(file) => {
              handleUpload(file);
            }}
            action=""
            listType="picture"
            className="upload"
            showUploadList={false}
          >
            <Button className="button-upload" icon={<UploadOutlined />}>
              Click to Upload
            </Button>
          </Upload>
        </div>
        <div
          style={{
            marginLeft: "20px",
            minWidth: "300px",
          }}
          className="list-container"
        >
          <div className="top-container">
            <div style={{ marginRight: "15px" }}>
              <Popconfirm
                title="Brisanje slike?"
                description="Da li ste sigurni da želite da izbrišete sve slike?"
                onConfirm={() => {
                  deleteGroupImages();
                }}
                onCancel={() => {}}
                okText="Da"
                cancelText="Ne"
              >
                <p className="delete-but">Obriši sve</p>
              </Popconfirm>
            </div>
          </div>
          <div className="inner-list">
            <CheckboxGroup style={{ width: "100%" }} value={checked}>
              <Image.PreviewGroup>
                <div className="all-img-list">
                  {photos.length > 0 &&
                    photos?.map((image: any, i: number) => {
                      let parts = image?.name?.split("-");
                      let result = {
                        firstFive: parts?.pop()?.substring(0, 15),
                        lastFour: image?.name?.slice(-15),
                      };

                      return (
                        <div className="upload-image-container" key={i}>
                          <div className="button-container">
                            <p></p>
                            <div style={{ marginRight: "15px" }}>
                              <Popconfirm
                                title="Brisanje slike?"
                                description="Da li ste sigurni da želite da izbrišete sliku?"
                                onConfirm={() => {
                                  deletePhoto(image);
                                }}
                                onCancel={() => {}}
                                okText="Da"
                                cancelText="Ne"
                              >
                                <DeleteOutlined style={{ cursor: "pointer" }} />
                              </Popconfirm>
                            </div>
                          </div>
                          <div className="image-header">
                            <Image
                              className="img"
                              src={`${storageUrl}${image.id}`}
                            />
                            <p>{`${result.firstFive}... ${result.lastFour}`}</p>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </Image.PreviewGroup>
            </CheckboxGroup>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateNewAlbumModal;
